export default __webpack_public_path__ + "static/media/ic-import.7f375a09.svg";